export default __webpack_public_path__ + "static/media/login-5.a3a1d8e4.svg";